import React from 'react';
import { Helmet } from 'react-helmet';
import './Home.css';

const Home = () => {
  return (
    <>
    <Helmet>
      <title>Services | GEMCO</title>
      <meta name="description" content="Explore Gemco’s specialist MEP services including supply, installation, retrofit, and maintenance solutions delivered with technical precision across the UAE." />
      <meta name="keywords" content="MEP services UAE, MEP contractors Dubai, MEP installation, MEP maintenance, MEP retrofit solutions, HVAC services UAE, electrical contracting UAE, plumbing services UAE, specialist MEP works, commercial MEP projects, industrial MEP solutions, Gemco UAE" />
    </Helmet>
    <div className='wp_home_service_wrap'>
        <div className="container wp_hero_text">
            <h1>Our Services</h1>
            <p>Specialist MEP supply, installation, retrofit and maintenance — delivered with
               technical precision across the UAE.</p>
        </div>
    </div>
    </>
  )
}

export default Home